import styled from "styled-components";

import Flex from "../../../atoms/flex";

export const Buttons = styled(Flex)`
  padding-top: 19px;
`;
